/**
 * Shared Google Maps control configuration.
 *
 * Every map in the GreenCharge frontend enables the native map-type +
 * fullscreen controls with the SAME defaults so the surfaces stay
 * consistent. Kept as plain options + persistence helpers so the same
 * file pattern can be copied across `greencharge-main`, `sw-ev-user`,
 * and `sw-ev-admin` without a shared package. No new npm dependency.
 */

const STORAGE_KEY = 'greencharge.mapType'
const VALID_MAP_TYPES = new Set(['roadmap', 'satellite', 'hybrid', 'terrain'])

export const SHARED_MAP_CONTROLS = Object.freeze({
    mapTypeControl: true,
    fullscreenControl: true,
})

export function readStoredMapType() {
    try {
        if (typeof window === 'undefined' || !window.localStorage) return null
        const v = window.localStorage.getItem(STORAGE_KEY)
        return VALID_MAP_TYPES.has(v) ? v : null
    } catch {
        return null
    }
}

export function writeStoredMapType(value) {
    try {
        if (typeof window === 'undefined' || !window.localStorage) return
        if (!VALID_MAP_TYPES.has(value)) return
        window.localStorage.setItem(STORAGE_KEY, value)
    } catch {
        /* storage disabled / quota / private mode — silent */
    }
}

export function initialMapType(fallback = 'roadmap') {
    return readStoredMapType() || fallback
}
